import React from 'react'
import { Column, Row } from '@vp/swan'
import type { TileSkin } from '../../types/sharedTypes'
import type { Tile } from '../../types/homepageFeatureTileRow'
import TileComponent from './Tile'

const SWAN_COLUMNS = 12

interface RowsTilesListProps {
  tiles: Array<Tile>
  visibleTiles: number
  tileSkin?: TileSkin
  loadType: string
  enableCampaignCallouts: boolean
  showPrice: boolean
  trackingPageZone: string
  locale: string
}

const RowsTilesList = (props: RowsTilesListProps) => {
  const { tiles, visibleTiles, tileSkin, loadType, enableCampaignCallouts, showPrice, trackingPageZone, locale } = props
  const tileColumnSpan = Math.round(SWAN_COLUMNS / visibleTiles) as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12

  return (
    <Row as="ul">
      {tiles.map((tile, index) => {
        return (
          <Column as="li" span={tileColumnSpan} key={index}>
            <TileComponent
              loadType={loadType}
              data={tile}
              position={index + 1}
              trackingPageZone={trackingPageZone}
              enableCampaignCallouts={enableCampaignCallouts}
              showPrice={showPrice}
              tileSkin={tileSkin}
              locale={locale}
              marginBottom={0}
            />
          </Column>
        )
      })}
    </Row>
  )
}

export default RowsTilesList
